import { authReducer } from './containers/auth/auth.reducers'
import { usersReducer } from './containers/users/users.reducers'
import { streetsReducer } from './containers/streets/streets.reducers'
import { streetTypesReducer } from './containers/street-types/street-types.reducers'
import { contactTypesReducer } from './containers/contact-types/contact-types.reducers'
import { formsReducer } from './containers/forms/forms.reducers'
import { imageTypesReducer } from './containers/image-types/image-types.reducers'
import { communitiesReducer } from './containers/communities/communities.reducers'
import { contactTitlesReducer } from './containers/contact-titles/contact-titles.reducers'
import { organizationsReducer } from './containers/organizations/organizations.reducers'
import { industriesReducer } from './containers/industries/industries.reducers'
import { propertiesReducer } from './containers/properties/properties.reducers'
import { sharedReducer } from './shared/shared.reducer'
import { templatesReducer } from './containers/templates/templates.reducers'
import { dataCyclesReducer } from './containers/data-cycles/data-cycles.reducers'
import { settingsReducer } from './containers/settings/settings.reducers'
import { propertyTypeTemplatesReducer } from './containers/property-type-templates/property-type-templates.reducers'
import { pdfBatchGenerationReducer } from './containers/pdf-batch-generation/pdf-batch-generation.reducers'
import { documentTypesReducer } from './containers/document-types/document-types.reducers'
import { businessesReducer } from './containers/businesses/businesses.reducers'
import { rolesReducer } from './containers/roles/roles.reducers'
import { financialInstitutionsReducer } from '@containers/financial-institutions/financial-institutions.reducers'
import { paymentPurposesReducer } from '@containers/payment-purposes/payment-purposes.reducers'
import { commercialLicenseMappingsReducer } from '@containers/commercial-license-mappings/commercial-license-mappings.reducers'
import { auditLogsReducer } from '@containers/audit-logs/audit-logs.reducers'
import { fixedTemplatesReducer } from '@containers/fixed-templates/fixed-templates.reducers'
import { reportsReducer } from '@containers/reports/reports.reducers'
import { mapReducer } from '@containers/map/map.reducers'
import { dashboardReducer } from '@containers/dashboard/dashboard.reducers'
import { wardsReducer } from '@containers/wards/wards.reducers'
import { searchReducer } from '@containers/search-results/search-results.reducers'
import { discountGroupsReducer } from '@containers/discount-groups/discount-groups.reducers'
import { profileReducer } from '@containers/profile/profile.reducers'
import { i18nReducer } from '@containers/i18n/store/i18n.reducers'
import { languagesReducer } from '@containers/languages/store/languages.reducers'
import { businessCategoriesReducer } from '@containers/business-categories/business-categories.reducers'
import { systemSettingsReducer } from '@containers/system-settings/system-settings.reducers'
import { securitySettingsReducer } from '@containers/security-settings/security-settings.reducers'
import { smtpSettingsReducer } from '@containers/smtp-settings/smtp-settings.reducers'
import { gisSettingsReducer } from '@containers/gis-settings/gis-settings.reducers'
import { pathSettingsReducer } from '@containers/path-settings/path-settings.reducers'
import { digitizationReducer } from '@containers/digitization/digitization.reducers'
import { unitsSettingsReducer } from '@containers/units-settings/units-settings.reducers'
import { layerReducer } from '@containers/layer/layer.reducers'
import { mobileUsersReducer } from '@containers/mobile-users/mobile-users.reducers'
import { mobileSettingsReducer } from '@containers/mobile-settings/mobile-settings.reducers'
import { staticContentTemplatesReducer } from '@containers/static-content-templates/static-content-templates.reducers'
import { mobileTasksReducer } from '@containers/mobile-tasks/mobile-tasks.reducers'
import { licenseGenerationSettingsReducer } from '@containers/license-generation-settings/license-generation-settings.reducers'
import { uiSettingsReducer } from '@containers/ui-settings/ui-settings.reducers'
import { compoundsReducer } from '@containers/compounds/compounds.reducers'
import { licenseTypesReducer } from '@containers/license-types/license-types.reducers'
import { notDeliveredReasonReducer } from '@containers/not-delivered-reason/not-delivered-reason.reducers'
import { externalDashboardsSettingsReducer } from '@containers/external-dashboard-settings/external-dashboard-settings.reducers'
import { formPostprocessorsReducer } from '@containers/form-postprocessors/form-postprocessors.reducers'
import { compoundSettingsReducer } from '@containers/compound-settings/compound-settings.reducers'
import { mapAnalyticsReducer } from '@containers/map-analytics/map-analytics.reducers'

const reducers = {
  auth: authReducer,
  users: usersReducer,
  streets: streetsReducer,
  streetTypes: streetTypesReducer,
  contactTypes: contactTypesReducer,
  imageTypes: imageTypesReducer,
  forms: formsReducer,
  communities: communitiesReducer,
  contactTitles: contactTitlesReducer,
  organizations: organizationsReducer,
  industries: industriesReducer,
  properties: propertiesReducer,
  templates: templatesReducer,
  dataCycles: dataCyclesReducer,
  settings: settingsReducer,
  propertyTypeTemplates: propertyTypeTemplatesReducer,
  pdfBatchGeneration: pdfBatchGenerationReducer,
  shared: sharedReducer,
  documentTypes: documentTypesReducer,
  businesses: businessesReducer,
  roles: rolesReducer,
  financialInstitutions: financialInstitutionsReducer,
  paymentPurposes: paymentPurposesReducer,
  commercialLicenseMappings: commercialLicenseMappingsReducer,
  auditLogs: auditLogsReducer,
  fixedTemplates: fixedTemplatesReducer,
  reports: reportsReducer,
  map: mapReducer,
  mapAnalytics: mapAnalyticsReducer,
  dashboard: dashboardReducer,
  wards: wardsReducer,
  search: searchReducer,
  discountGroups: discountGroupsReducer,
  profile: profileReducer,
  i18n: i18nReducer,
  languages: languagesReducer,
  businessCategories: businessCategoriesReducer,
  systemSettings: systemSettingsReducer,
  securitySettings: securitySettingsReducer,
  smtpSettings: smtpSettingsReducer,
  gisSettings: gisSettingsReducer,
  pathSettings: pathSettingsReducer,
  unitsSettings: unitsSettingsReducer,
  digitization: digitizationReducer,
  layer: layerReducer,
  mobileUsers: mobileUsersReducer,
  mobileSettings: mobileSettingsReducer,
  staticContentTemplates: staticContentTemplatesReducer,
  mobileTasks: mobileTasksReducer,
  licenseGenerationSettings: licenseGenerationSettingsReducer,
  uiSettings: uiSettingsReducer,
  compounds: compoundsReducer,
  licenseTypes: licenseTypesReducer,
  notDeliveredReason: notDeliveredReasonReducer,
  externalDashboardsSettings: externalDashboardsSettingsReducer,
  formPostprocessors: formPostprocessorsReducer,
  compoundSettings: compoundSettingsReducer,
}

export { reducers }
